__turbopack_context__.v({
  "day": "EG0_Mq_day",
  "month": "EG0_Mq_month",
  "tile": "EG0_Mq_tile",
});
